<template>
  <div class="container">
    <div class="header">
      <img class="img" src="../../assets/fff3@2x.png" alt="">
      <p class="title">邀请教练 赢iPad</p>
      <p class="tip">邀请身边教练朋友下载老虎教练APP，赢取超值大礼！</p>
    </div>
    <div class="warpper">
      <div class="btn" @click="joinin">我要参与</div>
    </div>
    <p class="rules">*参与本活动，即同意并遵守<span class="activity" @click="rules"><u>活动规则</u></span> <br> 本活动与苹果公司无关！</p>
  </div>
</template>

<script>
  import { Button,Toast } from 'mint-ui';
  import { join,joinActivity,wechatRedirect } from '@/api/api'

  export default {
    name: "index",
    data() {
      return {}
    },
    created() {
      if(this.$route.query.code && this.$route.query.state) {
        let code = this.$route.query.code
        let aid = this.$route.query.state
        this.getUserid(aid, code)
      } else if(this.$route.query.userid && this.$route.query.aid) {
        console.log('保存：' + this.$route.query.userid, this.$route.query.aid)
        let userid = this.$route.query.userid
        let aid = this.$route.query.aid
        sessionStorage.setItem('uid', userid)
        sessionStorage.setItem('aid', aid)
        this.getjoinstatus(aid, userid)
      }
    },
    methods: {
      async getUserid(aid, code) {
        try {
          let res = await wechatRedirect(aid, code)
          if(res.data.Code == 200) {
            let uid = res.data.Data.id
            sessionStorage.setItem('uid', uid)
            sessionStorage.setItem('aid', aid)
            sessionStorage.setItem('flag', 0)
            this.$router.push({
              name: "activityDetail"
            })

          } else if(res.data.Code == 403) {
            Toast({
              message: '无效Code',
              position: 'bottom',
              duration: 2000
            })
          } else if(res.data.Code == 411) {
            console.log('未参加过活动')
            let uid = res.data.Data.id
            sessionStorage.setItem('uid', uid)
            sessionStorage.setItem('aid', aid)
            sessionStorage.setItem('flag', 0)
          }
        } catch (e) {
          console.log(e)
          Toast({
            message: 'errCode: 10005',
            position: 'bottom',
            duration: 2000
          })
        }
      },
      async getjoinstatus(aid, uid) {
        try {
          let res = await join(aid, uid)
          if(res.data.Code == 200) {
            this.$router.push({
              name: "activityDetail"
            })
          } else if(res.data.Code == 411) {
            console.log('未参加过活动')
          }
          console.log(res)
        } catch (e) {
          e = e + ''
          if(e.indexOf('Network Error') > -1) {
            Toast({
              message: 'Network Error',
              position: 'bottom',
              duration: 2000
            })
          } else {
            Toast({
              message: 'errCode: 10000',
              position: 'bottom',
              duration: 2000
            })
          }
        }
      },
      async joinin() {
        try {
          let aid = sessionStorage.getItem('aid') 
          let uid = sessionStorage.getItem('uid')
          Toast({
            message: aid+ '' + uid,
            position: 'bottom',
            duration: 2000
          })
          let res = await joinActivity(aid, uid)
          if(res.data.Code == 200) {
            this.$router.push({
              name: "activityDetail"
            })
          } else if(res.data.Code == 412) {
            Toast({
              message: '你未绑定微信，不能参与此活动，快去绑定微信吧！',
              position: 'bottom',
              duration: 2000
            })
          } else {
            console.log('参加活动失败')
          }
          console.log(res)
        } catch (e) {
          // console.log(e)
          e = e + ''
          if(e.indexOf('Network Error') > -1) {
            Toast({
              message: 'Network Error',
              position: 'bottom',
              duration: 2000
            })
          } else {
            Toast({
              message: 'errCode: 10001',
              position: 'bottom',
              duration: 2000
            })
          }
        }
      },
      rules() {
        this.$router.push({
          name: "activityRules"
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .container {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: relative;
    background:linear-gradient(0deg,rgba(109,164,248,1) 0%,rgba(163,170,237,1) 19%,rgba(109,164,248,1) 37%,rgba(169,171,237,1) 56.00000000000001%,rgba(116,165,247,1) 75%,rgba(161,169,237,1) 100%);
    display: flex;
    // justify-content: center;
    // align-content: center;
    flex-wrap: wrap;
    .header {
      width: 100%;
      position: relative;
      height: 60%;
      display: flex;
      justify-content: center;
      align-content: flex-start;
      flex-wrap: wrap;
      color: #fff;
      .img {
        width: 2.86rem;
        height: 2.58rem;
        margin: 0.28rem 0 0.37rem;
      }
      .title {
        width: 100%;
        text-align: center;
        height: 0.36rem;
        line-height: .36rem;
        font-size: 0.24rem;
        font-weight: 600;
      }
      .tip {
        width: 100%;
        text-align: center;
        height: 0.36rem;
        line-height: .36rem;
        font-size: 0.12rem;
        font-weight: 500;
      }
    }
    .warpper {
      width: 100%;
      height: 40%;
      position: relative;
      overflow: hidden;
      .btn {
        width: 80%;
        margin: 0.27rem auto 0;
        height: 0.35rem;
        line-height: 0.35rem;
        text-align: center;
        background: #5167AA;
        border-radius: 0.1rem;
        font-size: 0.17rem;
        font-weight: 600;
      }
    }
    .rules {
      position: absolute;
      left: 0;
      bottom: 0.3rem;
      width: 100%;
      color: #fff;
      line-height: .2rem;
      font-size: 0.11rem;
      font-weight: 400;
      text-align: center;
      .activity {
        color: #F6C949;
      }
    }
  } 
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue